import { useEffect, useRef } from "react";
import { tg } from "../telegram";

/**
 * Show Telegram's native BackButton while the component is mounted; hide on
 * unmount. `onBack` fires when the user taps it.
 *
 * We register a SINGLE stable handler once (and read the latest `onBack` via a
 * ref). Re-calling BackButton.onClick/offClick on every render is unreliable in
 * several Telegram clients and can leave the button dead — registering once
 * avoids that entirely.
 */
export function useTelegramBackButton(onBack: () => void): void {
  const cb = useRef(onBack);
  cb.current = onBack;

  useEffect(() => {
    const t = tg();
    if (!t || !t.BackButton) return;
    const handler = () => cb.current();
    try {
      t.BackButton.onClick(handler);
      t.BackButton.show();
    } catch {
      return;
    }
    return () => {
      try {
        t.BackButton.offClick(handler);
        t.BackButton.hide();
      } catch {
        /* ignore */
      }
    };
  }, []);
}
